var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6004 9.59988C21.6004 13.5763 18.3768 16.7999 14.4004 16.7999C13.673 16.7999 12.9708 16.692 12.3089 16.4914L9.60039 19.1999H7.20039V21.5998H2.40039V16.7999L7.50888 11.6914C7.30826 11.0295 7.20039 10.3273 7.20039 9.59988C7.20039 5.62344 10.4239 2.3999 14.4004 2.3999C18.3768 2.3999 21.6004 5.62344 21.6004 9.59988ZM14.4004 4.79989C13.7376 4.79989 13.2004 5.33715 13.2004 5.99989C13.2004 6.66263 13.7376 7.19989 14.4004 7.19989C15.7259 7.19989 16.8004 8.2744 16.8004 9.59988C16.8004 10.2626 17.3377 10.7999 18.0004 10.7999C18.6631 10.7999 19.2004 10.2626 19.2004 9.59988C19.2004 6.94892 17.0514 4.79989 14.4004 4.79989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.b6524dfa6914e93177da5320d4b3af2e.svg";
export { ForwardRef as ReactComponent };